import { render } from "./SameProviderDialog.vue?vue&type=template&id=4d3a389c&scoped=true"
import script from "./SameProviderDialog.vue?vue&type=script&lang=js"
export * from "./SameProviderDialog.vue?vue&type=script&lang=js"

import "./dialogStyles.css?vue&type=style&index=0&id=4d3a389c&scoped=true&lang=css"
import "./SameProviderDialog.vue?vue&type=style&index=1&id=4d3a389c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3a389c"]])

export default __exports__